import React, { useCallback, useState } from "react";

import moment from "moment";
import { useTranslation } from "react-i18next";

import { Disclosure } from "@headlessui/react";
import { useNotification } from "@hooks/useNotification";
import {
  AlerteDate,
  SvgBlackTrash,
  SvgMenuExpenses,
  SvgShapeDropdown,
  SvgUpdateAssignationIcon
} from "@routes/IconeSvg";

import SharedViewFile from "@components/modals/SharedViewFile";
import { Menu } from "@components/tailwindComponents";
import Button from "@components/tailwindComponents/Button";
import EmptyData from "@components/tailwindComponents/EmptyData";
import BlackTooltip from "@components/tooltip/BlackTooltip";

import { formatValidDate } from "@helpers/_functions";
import {
  EventUnavalaibilityService,
  UnavailabilityService
} from "@services/all.services";

// import ModalUpdateUnavailability from "./updateUnavailability";
import ModalUpsertUnavailability from "./ModalUpsertUnavailability";
import ModalNewEvent from "./newEvent";

export default function UnavailabilityListTable(props) {
  const { unavailabilityList = [], readOnly, employeeId } = props;
  const { t: translator } = useTranslation("pages.employés.emploi&Salary");
  const { showError, showSuccess } = useNotification();
  const [showModalNewEvent, setShowModalNewEvent] = useState(false);
  const [showModalUnav, setShowModalUnav] = useState(false);
  const [unaivalabilitySelected, setUnavailability] = useState(null);
  const [dataEvent, setDataEvent] = useState({});
  const [file, setFile] = useState({});
  const [files, setFiles] = useState([]);
  const [sharedViewFile, setShowFile] = useState(false);
  const [idCollapseActivated, setActiveCollapse] = useState(null);

  function deleteUnavailability(ev, id) {
    ev.preventDefault();

    UnavailabilityService.deleteById(id)
      .then(() => {
        props.removeUnavailability(id);
        showSuccess("delete_period_unav");
      })
      .catch((error) => {
        console.error(error);
        showError("error_occured", {
          mode: "action_mode_delete",
          object: "unav"
        });
      });
  }

  function deleteEvent(ev, id) {
    ev.preventDefault();

    EventUnavalaibilityService.deleteById(id)
      .then(() => {
        showSuccess("delete_action_success", { object: "eventUpper" });
      })
      .catch((error) => {
        console.error(error);
        showError("error_occured", {
          mode: "action_mode_delete",
          object: "unav"
        });
      });
  }

  function EditUnavailability(dataUnav) {
    if (dataUnav?._id) {
      setUnavailability(dataUnav);
    } else {
      setUnavailability({});
    }
    setShowModalUnav(true);
  }

  function CloseModalUnavailability() {
    setShowModalUnav(false);
  }

  const onClickNewEvent = useCallback((dataUnav, data = {}) => {
    setShowModalNewEvent((showModalNewEvent) => !showModalNewEvent);
    if (dataUnav?._id) {
      setUnavailability(dataUnav);
      setDataEvent(data);
      setFiles(data?.files);
    } else {
      setUnavailability({});
      setDataEvent({});
    }
  }, []);

  const showPeriod = (start, end) =>
    `${translator("DU")} ${moment(start).format("LL")} – ${translator("AU")} ${moment(end).format("LL")}`;

  const onClickShowFile = (file) => {
    setShowFile(!sharedViewFile);
    setFile(file);
  };
  const onActiveCollapse = (id) => setActiveCollapse(id);
  const tableMinWidthClass = readOnly
    ? "arh-min-w-[640px]"
    : "arh-min-w-[900px]";

  return unavailabilityList?.length ? (
    <>
      <Disclosure>
        {({ open }) => (
          <div className="arh-mb-6 arh-overflow-x-auto arh-font-poppins">
            <table
              className={`arh-w-full ${tableMinWidthClass} arh-table-auto`}
            >
              <thead className="arh-bg-greyColor arh-font-semibold arh-text-darkColor">
                <tr className="arh arh-border arh-border-x-0 arh-border-b arh-border-t-0 arh-border-solid arh-border-greyBorderInput arh-px-5 arh-text-xs">
                  <th
                    className={`${
                      readOnly ? "arh-w-[46%]" : "arh-w-[32%]"
                    } arh-whitespace-nowrap arh-px-5 arh-py-3 arh-text-left arh-text-xs`}
                  >
                    {translator("Période d'indisponibilité")}
                  </th>
                  <th
                    colSpan={readOnly ? 5 : 1}
                    className={`${
                      readOnly
                        ? "arh-w-[54%] arh-px-8"
                        : "arh-w-[18%] arh-px-5"
                    } arh-text-left arh-text-xs`}
                  >
                    {translator("Type d'indisponibilité")}
                  </th>
                  {!readOnly && (
                    <>
                      <th className="arh-w-[20%] arh-px-5 arh-text-left arh-text-xs">
                        Notes
                      </th>
                      <th className="arh-w-[8%] arh-px-5 arh-text-xs">&nbsp;</th>
                      <th className="arh-w-[18%] arh-px-5 arh-text-xs">&nbsp;</th>
                      <th className="arh-w-[4%] arh-px-5 arh-text-xs">&nbsp;</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody className="arh-font-medium arh-text-darkGreyColor">
                {unavailabilityList.map((unav) => (
                  <>
                    <tr
                      key={unav?._id}
                      className={`${open && unav?._id === idCollapseActivated ? "arh-border-none" : "arh-border arh-border-x-0 arh-border-b arh-border-t-0 arh-border-solid arh-border-greyBorderInput"} arh-px-5 arh-text-xs hover:arh-bg-greyColor`}
                      onClick={() => onActiveCollapse(unav?._id)}
                    >
                      <td className="arh-whitespace-nowrap arh-py-3 arh-pl-5 arh-pr-8 arh-text-xs ">
                        <div className="arh-flex arh-cursor-pointer arh-items-center arh-whitespace-nowrap">
                          <Disclosure.Button
                            className="arh-mr-2 arh-border-0 arh-bg-transparent arh-font-poppins arh-text-xs arh-font-medium arh-text-darkGreyColor"
                            as="div"
                          >
                            <div
                              className={`${
                                open && unav?._id === idCollapseActivated
                                  ? "arh-w-fit arh-rotate-0 arh-transform"
                                  : "arh-w-fit -arh-rotate-90"
                              }`}
                            >
                              {SvgShapeDropdown()}
                            </div>
                          </Disclosure.Button>
                          <Disclosure.Button
                            as="div"
                            className="arh-flex arh-flex-nowrap arh-items-center arh-whitespace-nowrap arh-border-0 arh-bg-transparent arh-font-poppins arh-text-xs arh-font-medium arh-text-[#393C40]"
                          >
                            {showPeriod(
                              unav?.beginningOfPeriod,
                              unav?.endOfPeriod
                            )}
                          </Disclosure.Button>
                        </div>
                      </td>
                      <td
                        colSpan={readOnly ? 5 : 1}
                        className={`${
                          readOnly ? "arh-px-8" : "arh-px-5"
                        } arh-text-xs`}
                      >
                        {unav?.type || "-"}
                      </td>

                      {!readOnly && (
                        <td className="arh-px-5 arh-text-xs">
                          <BlackTooltip
                            title={unav?.notes || "-"}
                            placement="top-start"
                          >
                            <div className="arh-line-clamp-2 arh-w-full arh-font-poppins arh-text-xs arh-font-medium arh-text-[#393C40]">
                              {unav?.notes || "-"}
                            </div>
                          </BlackTooltip>
                        </td>
                      )}
                      {!readOnly && (
                        <td className="arh-px-5 arh-py-3 arh-text-xs "></td>
                      )}
                      {!readOnly && (
                        <td className="arh-px-5 arh-py-3 arh-text-xs">
                          <Button
                            onClick={() => onClickNewEvent(unav)}
                            variant="green-outlined"
                            className=" arh-mr-[0.3rem]"
                          >
                            {translator("Ajouter un événement")}
                          </Button>
                        </td>
                      )}

                      {!readOnly && (
                        <td className="arh-px-5 arh-py-3 arh-text-xs">
                          <Menu
                            lists={[
                              {
                                icon: <SvgUpdateAssignationIcon />,
                                title: translator("Modifier"),
                                click: (e) => EditUnavailability(unav)
                              },
                              {
                                icon: <SvgBlackTrash />,
                                title: translator("Effacer"),
                                click: (e) => deleteUnavailability(e, unav._id)
                              }
                            ]}
                            withIcon
                          />
                        </td>
                      )}
                    </tr>
                    {/* Entete du tableau en closure */}
                    {unav?._id === idCollapseActivated && open && (
                      <>
                        <tr colSpan={6}>
                          <div className="arh-my-4"></div>
                        </tr>
                        <tr className="arh-border-b-8 arh-border-solid arh-border-white arh-bg-greyColor arh-transition arh-duration-300 arh-ease-in">
                          <td className="arh-px-5 arh-py-2 arh-text-xs ">
                            {translator("Événement")}
                          </td>
                          <td className="arh-whitespace-nowrap arh-px-5 arh-py-2 arh-text-xs ">
                            {translator("Période")}
                          </td>
                          <td className="arh-px-5 arh-py-2 arh-text-xs ">
                            Notes
                          </td>
                          <td className="arh-px-5 arh-py-2 arh-text-xs ">
                            {translator("Fichier")}
                          </td>
                          <td className="arh-px-5 arh-py-2 arh-text-xs ">
                            {translator("Alertes")}
                          </td>
                          <td className="arh-px-5 arh-py-2 arh-text-xs "></td>
                        </tr>
                        {/* Corps du tableau en closure */}

                        {unav?.events?.length ? (
                          unav?.events?.map((event) => (
                            <Disclosure.Panel
                              as="tr"
                              key={event?._id}
                              className="arh-border arh-border-x-0 arh-border-b arh-border-t-0 arh-border-solid arh-border-greyBorderInput arh-px-5 arh-text-xs hover:arh-bg-greyColor"
                            >
                              <td className="arh-px-5 arh-py-2 arh-text-xs ">
                                {event?.title}
                              </td>
                              <td className="arh-whitespace-nowrap arh-px-5 arh-py-2 arh-text-xs ">
                                <div className="arh-flex arh-w-full arh-flex-nowrap arh-items-center arh-whitespace-nowrap arh-font-poppins arh-text-xs arh-font-medium arh-text-[#393C40]">
                                  {showPeriod(
                                    event?.beginPeriod,
                                    event?.endPeriod
                                  )}
                                </div>
                              </td>
                              <td className="arh-px-5 arh-py-2 arh-text-xs ">
                                {event?.notes ? (
                                  <BlackTooltip
                                    title={event?.notes}
                                    placement="top-start"
                                  >
                                    <div className="arh-line-clamp-2 arh-w-full arh-font-poppins arh-text-xs arh-font-medium arh-text-[#393C40]">
                                      {event?.notes}
                                    </div>
                                  </BlackTooltip>
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td className="arh-px-5 arh-py-2 arh-text-xs">
                                <div className="arh-flex arh-flex-col arh-space-y-2">
                                  {event?.files?.length
                                    ? event?.files?.map((_file) => (
                                        <BlackTooltip
                                          title={_file?.filename}
                                          placement="top"
                                          key={_file._id}
                                        >
                                          <div
                                            className="arh-flex arh-w-full arh-cursor-pointer arh-items-center arh-justify-start arh-space-x-2 hover:arh-underline "
                                            onClick={() =>
                                              onClickShowFile(_file)
                                            }
                                          >
                                            <span>{SvgMenuExpenses()}</span>
                                            <span className="arh-block arh-w-full arh-truncate">
                                              {_file?.filename}
                                            </span>
                                          </div>
                                        </BlackTooltip>
                                      ))
                                    : "-"}
                                </div>
                              </td>
                              <td className="arh-px-5 arh-py-2 arh-text-xs ">
                                {event?.alertDate ? (
                                  <div className="arh-flex arh-items-center">
                                    {AlerteDate()}
                                    <span className="arh-ml-[0.5rem] arh-whitespace-nowrap arh-font-poppins arh-text-xs arh-font-medium arh-text-[#393C40]">
                                      {formatValidDate(event?.alertDate)}
                                    </span>
                                  </div>
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td className="arh-px-5 arh-py-2 arh-text-xs ">
                                {!readOnly && (
                                  <Menu
                                    lists={[
                                      {
                                        icon: <SvgUpdateAssignationIcon />,
                                        title: translator("Modifier"),
                                        click: (e) =>
                                          onClickNewEvent(unav, event)
                                      },
                                      {
                                        icon: <SvgBlackTrash />,
                                        title: translator("Effacer"),
                                        click: (e) => deleteEvent(e, event._id)
                                      }
                                    ]}
                                    withIcon
                                  />
                                )}
                              </td>
                            </Disclosure.Panel>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={6}>
                              <EmptyData>
                                {translator("Aucun resultat à afficher")}
                              </EmptyData>
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Disclosure>

      {/* Modals */}
      <ModalNewEvent
        show={showModalNewEvent}
        onClickClose={onClickNewEvent}
        employeeId={employeeId}
        unaivalabilitySelected={unaivalabilitySelected}
        event={dataEvent}
        oldFilesFromBD={files}
      />

      <SharedViewFile
        onClickClose={onClickShowFile}
        show={sharedViewFile}
        file={file}
        t={translator}
      />
      <ModalUpsertUnavailability
        unavailabilityList={unavailabilityList}
        refreshUnavailabilityList={props.refreshUnavailabilityList}
        closeModal={CloseModalUnavailability}
        isOpen={showModalUnav}
        employeeId={employeeId}
        unavailabilitySelected={unaivalabilitySelected}
      />
    </>
  ) : readOnly ? (
    <EmptyData>{translator("Aucun élément")}</EmptyData>
  ) : (
    ""
  );
}
